/** Shopify CDN: Minification failed

Line 57:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 57:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 57:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 50:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 50:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 43:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 43:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 36:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 36:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 36:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 29:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 29:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 22:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 22:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 22:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 15:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 8:255 Transforming const to the configured target environment ("es5") is not supported yet
Line 8:489 Transforming let to the configured target environment ("es5") is not supported yet
Line 8:1905 Transforming let to the configured target environment ("es5") is not supported yet

**/
function isMobileScreen() {
  return window.innerWidth <= 600;
}
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".add-to-cart-button").forEach((e) => {
    e.addEventListener("click", (e) => {
      var t = e.currentTarget.getAttribute("data-product");
      const r = document.getElementById(`size-selection-modal--${t}`);
      setTimeout(() => {
        isMobileScreen() ? r.classList.add("open") : r.classList.add("fade-in");
      }, 0);
    });
  });
  var e = document.getElementsByClassName("size-selection-modal--close-button");
  for (let t = 0; t < e.length; t++)
    e[t].onclick = function () {
      var e = this.parentNode.parentNode;
      e.classList.remove("open"), e.classList.remove("fade-in");
    };
  window.onclick = function (e) {
    e.target.classList.contains("size-selection-modal") &&
      (e.target.classList.remove("open"), e.target.classList.remove("fade-in"));
  };
  var t = document.querySelector(".Product__SlideshowNavScroller");
  if (t) {
    var r = document.getElementById(
        "Product__SlideshowNav--thumbnails--Container"
      ),
      n = document.getElementById("Product__SlideshowNav--thumbnails--arrow"),
      l = function () {
        r.scrollTop = r.scrollHeight;
      },
      a = function () {
        r.scrollTop = 0;
      };
    Array.from(t.children).filter(function (e) {
      return "none" !== getComputedStyle(e).display;
    }).length > 4 &&
      ((n.style.display = "inline-block"),
      n.addEventListener("click", l),
      r.addEventListener("scroll", function () {
        r.scrollTop + r.clientHeight >= r.scrollHeight
          ? ((n.style.webkitTransform =
              "translateX(15px) translateY(-25px) rotate(-45deg)"),
            (n.style.transform =
              "translateX(15px) translateY(-25px) rotate(-45deg)"),
            n.removeEventListener("click", l),
            n.addEventListener("click", a))
          : ((n.style.webkitTransform =
              "translateX(15px) translateY(-30px) rotate(135deg)"),
            (n.style.transform =
              "translateX(15px) translateY(-30px) rotate(135deg)"),
            n.removeEventListener("click", a),
            n.addEventListener("click", l));
      }));
  }
});
// Keep your existing code structure
var productItems = document.querySelectorAll(".ProductItem");

productItems.forEach(function (e) { // 'e' is the current ProductItem element
    // Keep all your original variable declarations and element selections here
    var t = JSON.parse(e.getAttribute("data-media")),
        r = e.dataset.currentCollection;
    // This filter logic 'n' defines the subset of images we are cycling through
    let n = t.filter((mediaItem) => (r.toUpperCase().includes("WOMEN") ? !mediaItem.alt.toUpperCase().includes("MAN") : !r.toUpperCase().includes("MEN") || !mediaItem.alt.toUpperCase().includes("WOMEN")));

    // Select the elements *within this ProductItem*
    var l = e.querySelector("#main-image"), // Main image element
        a = e.querySelector("#next-image"), // Next image element (preloaded?)
        c = e.querySelector(".next"), // Next arrow element for *this* product item
        i = e.querySelector(".prev"); // Prev arrow element for *this* product item

    // Select the pagination container *within this ProductItem*
    const paginationContainer = e.querySelector('.product-image-pagination'); // !!! Replace .product-image-pagination if you used a different class !!!

    // Select the element to attach swipe listeners to
    // This is likely the image wrapper or the ProductItem element itself ('e')
    const swipeTargetElement = e; // Or e.querySelector('.your-specific-image-wrapper-class');

    // Initialize the current image index for this product item instance
    // Use the index within the FILTERED media array (n)
    // The findIndex logic in your original code seemed to be discarded, so let's stick to 0 as the starting point.
    var s = 0; // s is the index within the 'n' array (the filtered media)


    // Check if necessary elements exist for this specific product item instance
    // It's important to have at least the main image, arrows, and pagination container
    if (!l || !c || !i || !paginationContainer || !swipeTargetElement || n.length === 0) {
      // If we can't find essential elements or there are no filtered images,
      // log a warning and skip processing this product item instance.
      console.warn('Missing essential elements or no filtered media for a product item instance.', e);
      return;
    }

    // --- Refactored function to update UI (image and dots) based on the current index 's' ---
    // This function reads the value of 's' and updates the display accordingly.
    // It DOES NOT change the value of 's'.
    function updateUI() {
        // Ensure s is within valid bounds (should be handled by index updates, but good fallback)
        if (s >= n.length || s < 0) {
           s = 0; // Reset to first image if index is out of bounds
        }

        // --- Update Main Image Attributes ---
        // Use setAttribute for data-* attributes for consistency
        l.src = n[s].url;
        l.alt = n[s].alt;
        // Set srcset for responsive images if needed - using url for simplicity here
        l.srcset = n[s].url; // You might want to generate actual responsive srcset here
        l.setAttribute("data-srcset", n[s].url); // Assuming you use data-srcset


        // --- Update Next Image Attributes (for preloading) ---
        // Calculate the index of the NEXT image based on the current s
        let currentNextIndex = (s + 1) % n.length; // Use modulo for clean wrap around

        // Check if the 'next-image' element exists before trying to update it
        if (a) {
            a.src = n[currentNextIndex].url;
            a.alt = n[currentNextIndex].alt;
            a.srcset = n[currentNextIndex].url;
            a.setAttribute("data-srcset", n[currentNextIndex].url);
        }

        // --- Update Pagination Dots ---
        const dots = paginationContainer.querySelectorAll('.pagination-dot');
        // Remove 'active' class from all dots first
        dots.forEach(dot => dot.classList.remove('active'));

        // Add 'active' class to the dot corresponding to the current index 's'
        if (dots[s]) { // Check if a dot exists for the current index 's'
             dots[s].classList.add('active');
        }
    }

    // --- Create Pagination Dots ---
    // Clear any existing dots before creating new ones (important if this script runs multiple times)
    paginationContainer.innerHTML = '';
    if (n.length > 1) { // Only create dots if there's more than one filtered image
        n.forEach((media, index) => {
            const dot = document.createElement('span');
            dot.classList.add('pagination-dot');
            dot.dataset.index = index; // Store the index the dot represents

            // Add click listener to each dot
            dot.addEventListener('click', function() {
                const clickedIndex = parseInt(this.dataset.index, 10);
                // Check if the clicked dot is different from the current active one
                if (clickedIndex !== s) {
                   s = clickedIndex; // *** Update the index 's' directly ***
                   updateUI(); // *** Call updateUI based on the new value of 's' ***
                }
            });

            paginationContainer.appendChild(dot); // Add the dot to the container
        });
    }


    // --- Set Initial State ---
    // Call updateUI for the initial index (which is 0) to display the first image and activate the first dot.
    // 's' is already initialized to 0.
    updateUI();


    // --- Original Arrow Click Handlers (Modified to update 's' and then call updateUI) ---
    // These handlers are now the *only* place where 's' is incremented/decremented directly by arrow clicks.
    // They calculate the new index, update 's', and then call updateUI.
    c.addEventListener("click", function () {
        // Calculate the next index with wrap around using modulo
        s = (s + 1) % n.length;
        updateUI(); // Update the UI based on the newly calculated index 's'
    });

    i.addEventListener("click", function () {
        // Calculate the previous index with wrap around
        // (s - 1) could be negative, adding n.length makes it positive before modulo
        s = (s - 1 + n.length) % n.length;
        updateUI(); // Update the UI based on the newly calculated index 's'
    });


    // --- Existing Touch Swipe Logic (Triggers clicks) ---
    // This part remains the same. It simulates a click on the arrows.
    // Because the arrow click handlers now correctly update 's' and call 'updateUI'
    // the swipe gesture indirectly triggers the correct sequence.
    const swipeThreshold = 30; // Adjust as needed
    let startX = 0;
    let startY = 0;
    let isSwiping = false;

    swipeTargetElement.addEventListener('touchstart', function(event) {
      if (event.touches.length === 1) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        isSwiping = false;
      }
    });

    swipeTargetElement.addEventListener('touchmove', function(event) {
      if (event.touches.length === 1) {
        const currentX = event.touches[0].clientX;
        const currentY = event.touches[0].clientY;
        const diffX = currentX - startX;
        const diffY = currentY - startY;

        // Determine if the user is trying to swipe horizontally vs. scroll vertically
        if (!isSwiping && Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
            isSwiping = true;
        }

        // If we've determined it's likely a horizontal swipe, prevent default vertical scrolling
        // Check if preventDefault is available before calling it (some passive listeners can't be prevented)
        if (isSwiping && event.cancelable) {
          event.preventDefault();
        }
      }
    });

    swipeTargetElement.addEventListener('touchend', function(event) {
      // Check if it was potentially a swipe and a touch ended on this element
      if ((startX !== 0 || startY !== 0) && event.changedTouches.length > 0) {
          const endX = event.changedTouches[0].clientX;
          const displacementX = endX - startX;

          // Check if the displacement is significant enough and a swipe was detected during move
          if (isSwiping && Math.abs(displacementX) >= swipeThreshold) {
            if (displacementX > 0) {
              // Swiped right - Trigger Previous Arrow click
              // This click will call the modified i.addEventListener which updates 's' and calls updateUI
              i.click();
            } else {
              // Swiped left - Trigger Next Arrow click
              // This click will call the modified c.addEventListener which updates 's' and calls updateUI
              c.click();
            }
          }
      }
      // Reset variables regardless of whether a swipe was detected
      startX = 0;
      startY = 0;
      isSwiping = false;
    });

    swipeTargetElement.addEventListener('touchcancel', function() {
       startX = 0;
       startY = 0;
       isSwiping = false;
    });

}); // End of productItems.forEach loop
var firstCollapsibleButton = document.querySelector(
  ".Product__Tabs > div > .Collapsible__Button "
);
firstCollapsibleButton && firstCollapsibleButton.click();
var $carousel = $("#slideshow_media").flickity(),
  $carouselNav = $(".Product__SlideshowNavScroller");
$carouselNav.on("click", ".carousel-cell", function (e) {
  var t = e.currentTarget.getAttribute("data-position-index");
  $carousel.flickity("select", t),
    $carouselNav.find(".is-selected").removeClass("is-selected"),
    e.currentTarget.querySelector("a") &&
      e.currentTarget.querySelector("a").classList.add("is-selected"),
    adjustHeight();
});
var mainImage = document.querySelector(".Product__SlideItem--image"),
  thumbnailDiv = document.querySelector(".Product__SlideshowNav--thumbnails");
function adjustHeight() {
  var e = document.querySelector(".Product__SlideItem--image"),
    t = document.querySelector(".Product__SlideshowNav--thumbnails");
  t &&
    ((t.style.height = e.offsetHeight + "px"),
    (t.style.width = (e.offsetHeight / 4) * 0.823328 + "px"));
}
thumbnailDiv &&
  ((thumbnailDiv.style.height = mainImage.offsetHeight + "px"),
  (thumbnailDiv.style.width = (mainImage.offsetHeight / 4) * 0.823328 + "px")),
  (window.onload = function () {
    adjustHeight();
  }),
  (window.onresize = function () {
    adjustHeight();
  });

